import { MoreVert, PersonAdd, Storefront } from "@mui/icons-material";
import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";
import {
  IUserResponse,
  RoleTranslations,
} from "../../../clients/answeringClient";
import { RolesEnum } from "../../../utils/getUserRolesFromToken";

interface Props {
  user: IUserResponse;
  onPromoteClick: (uid: string, name: string) => void;
  roleTranslations?: RoleTranslations;
  onPromotePsychologist: (uid: string, name: string) => void;
}

const AllUsersRow: React.FC<Props> = ({
  user,
  onPromoteClick,
  roleTranslations,
  onPromotePsychologist,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const name = `${user.firstName} ${user.lastName}`;
  const email = user.email ?? "N/A";
  const roles = user.roles || [];
  const isReseller = roles.includes(RolesEnum.RESELLER);
  const isPsychologist = roles.includes(RolesEnum.PSYCHOLOGIST);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handlePromote = () => {
    onPromoteClick(user.uid, name);
    handleMenuClose();
  };
  const handlePromotePsy = () => {
    onPromotePsychologist(user.uid, name);
    handleMenuClose();
  };

  return (
    <TableRow hover>
      <TableCell>{name}</TableCell>
      <TableCell>{email}</TableCell>
      <TableCell>
        {roles.length > 0
          ? roles.map((role) => {
              const translated = roleTranslations?.[role] ?? role;
              return (
                <Chip
                  color="secondary"
                  key={role}
                  label={translated}
                  size="small"
                  sx={{ mr: 0.5 }}
                  title={role !== translated ? `(${role})` : undefined}
                />
              );
            })
          : "Nenhum papel"}
      </TableCell>
      <TableCell align="right">
        <IconButton
          size="medium"
          sx={{
            backgroundColor: "grey.200",
            color: "primary.main",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
          onClick={handleMenuOpen}
          aria-label="abrir menu de ações"
        >
          <MoreVert />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {isReseller ? (
            <Tooltip title="Este usuário já é um revendedor" placement="left">
              <div>
                <MenuItem disabled>
                  <Storefront fontSize="small" sx={{ mr: 1 }} />
                  Promover para Revendedor
                </MenuItem>
              </div>
            </Tooltip>
          ) : (
            <MenuItem onClick={handlePromote}>
              <Storefront fontSize="small" sx={{ mr: 1 }} />
              Promover para Revendedor
            </MenuItem>
          )}
          {isPsychologist ? (
            <Tooltip title="Este usuário já é um psicólogo" placement="left">
              <div>
                <MenuItem disabled>
                  <PersonAdd fontSize="small" sx={{ mr: 1 }} />
                  Promover para Psicólogo
                </MenuItem>
              </div>
            </Tooltip>
          ) : (
            <MenuItem onClick={handlePromotePsy}>
              <PersonAdd fontSize="small" sx={{ mr: 1 }} />
              Promover para Psicólogo
            </MenuItem>
          )}
        </Menu>
      </TableCell>
    </TableRow>
  );
};

export default AllUsersRow;
